require("./leonSans")

const sw = 340
const sh = 80
const pixelRatio = 2

export default class Logo extends Component {
  firstRender = true

  drawLogo = el => {
    if (!el) return

    const ctx = el.getContext("2d")
    ctx.scale(pixelRatio, pixelRatio)
    this.leon = new LeonSans({
      text: "CIRCUITS",
      color: ["#342f2e"],
      weight: 400,
      size: 60,
    })

    const x = sw / 2
    const y = sh / 2

    if (this.firstRender) {
      const animate = t => {
        requestAnimationFrame(animate)
        ctx.clearRect(0, 0, sw, sh)
        this.leon.draw(ctx)
      }

      animate()
    }

    this.firstRender = false

    setTimeout(this.onDraw, 0)
  }

  onDraw = () => {
    let i,
      total = this.leon.drawing.length
    for (i = 0; i < total; i++) {
      TweenMax.killTweensOf(this.leon.drawing[i])
      TweenMax.fromTo(
        this.leon.drawing[i],
        4,
        {
          value: -0.1,
        },
        {
          delay: i * 0.22,
          value: 1,
          ease: Power4.easeOut,
        },
      )
    }
  }

  render() {
    return (
      <Surface>
        <canvas
          width={sw * pixelRatio}
          heigth={sh * pixelRatio}
          style={{ width: sw, height: sh }}
          ref={this.drawLogo}
        />
      </Surface>
    )
  }
}
